<template>
    <v-container>
        <v-row>
            <v-col>
                <v-select v-model="selected" color="#c42111" :items="param.rpt_param_values" @change="onChange" />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'SingleSelect',
    props: ['param'],
    data: () => ({
        selected: null,
        items: []
    }),

    computed: {

    },

    methods: {
        onChange: function(val) {
            this.param.selectedValue = `${this.items.indexOf(this.selected)}`;
            this.param.humanText = this.selected;

            this.$emit('edit');
        },

        buildList: function() {
            this.items = this.param.rpt_param_values;
        },

        setInputsInitialValue: function() {
            if(this.$props.param.encodedValue == undefined) {
                this.selected = this.items[0];
                return;
            }
            this.selected = this.items[this.$props.param.encodedValue];
        }
    },

    mounted() {
        this.buildList();
        this.setInputsInitialValue();
        this.onChange();
    }

  
};
</script>

<style scoped>


</style>

